import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { DashboardServiceService } from '../../services/dashboard-service.service';
import { UnsubscribeModalComponent } from '../../modals/unsubscribe-modal/unsubscribe-modal.component';
import { EndSubscriptionComponent } from '../../modals/end-subscription/end-subscription.component';
import { SeatsNotAvailableComponent } from '../../modals/seats-not-available/seats-not-available.component';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css'],
})
export class MapsComponent implements OnInit {
  isLoaded: boolean;
  isEdit: boolean;
  selectFontSize: any = 12
  unSubscribeArray: number[] = [];
  mapsName: any[] = [];

  subscriptionsArray: any;
  sharedMaps: any;
  mapTitle: any;
  value: any;
  component: any;
  yes: any;
  no: any;
  showUnsubMessage: any;
  updateSetting: any;
  activeMapAvailable: any;
  fontSize = 12
  share = '';
  showText: any

  constructor(
    public dashboardService: DashboardServiceService,
    private dialog: MatDialog,
    private mapServices: MapServiceService,
    private router: Router,
    private global: GlobalService
  ) {
    this.isLoaded = false;
    this.isEdit = false;
  }

  ngOnInit(): void {
    localStorage.removeItem('fontSize');
    localStorage.setItem("fontSize", this.selectFontSize)
    this.dashboardService.redirectSettingUpdated.subscribe(() => {
      this.checkStatus();
    });

    if (this.dashboardService.mapsAndProfile != null) {
      this.updateData();
    }

    this.dashboardService.dataLoaded.subscribe(() => {
      this.updateData();
    });

    this.checkStatus();

    this.dashboardService.clearData.subscribe(() => {
      this.mapsName = [];
      this.unSubscribeArray = [];
      setTimeout(() => {
        this.dashboardService.getDashboardData().subscribe((res) => {
          this.dashboardService.mapsAndProfile = res;
          this.ngOnInit();
          this.isEdit = false;
        });
      }, 2000);
    });
  }

  //check direct login current status
  checkStatus() {
    if (
      localStorage.getItem('redirect') == 'True' ||
      localStorage.getItem('redirect') == 'true'
    ) {
      this.yes = true;
      this.no = false;
      this.value = 'true';
    } else {
      this.yes = false;
      this.no = true;
      this.value = 'false';
    }
  }

  updateData(): void {
    //handle dynamic modal
    this.mapServices.dynamicModalCheck(
      '',
      this.mapServices.isLiveShareLink,
      true,
      false
    );
    this.subscriptionsArray = this.dashboardService.mapsAndProfile.My_maps;
    const data = this.dashboardService.mapsAndProfile.shared_maps;
    this.sharedMaps = this.uniqByKeepFirst(data, (it: any) => it.slug)

    if (this.subscriptionsArray !== 0 && this.subscriptionsArray) {
      //sort my maps
      this.subscriptionsArray.sort((a: any, b: any) =>
        a.map_name.localeCompare(b.map_name)
      );
      this.checkCancelledStatus();
    } else {
      this.subscriptionsArray = [];
    }
    if (this.sharedMaps.length !== 0 && this.sharedMaps) {
      //sort shared maps
      this.sharedMaps.sort((a: any, b: any) => a.name.localeCompare(b.name));
    } else {
      this.sharedMaps = [];
    }

    this.isLoaded = true;
  }
  uniqByKeepFirst(a: any, key: any) {
    const seen = new Set();
    return a.filter((item: any) => {
      const k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }
  editSubscription(): void {
    this.isEdit = true;
  }

  checkCancelledStatus(): void {
    // check if any cancel map is available
    for (let i = 0; i < this.subscriptionsArray.length; i++) {
      if (this.subscriptionsArray[i].status == 'canceled') {
        this.showUnsubMessage = true;
        break;
      }
    }

    // check if any active map is available
    for (let i = 0; i < this.subscriptionsArray.length; i++) {
      if (
        this.subscriptionsArray[i].status == 'active' ||
        this.subscriptionsArray[i].status == 'canceled' ||
        this.subscriptionsArray[i].status == '' ||
        this.subscriptionsArray[i].status == null
      ) {
        this.activeMapAvailable = true;
        break;
      }
    }
  }

  back(): void {
    this.isEdit = false;
    this.mapsName = [];
    this.unSubscribeArray = [];
    this.ngOnInit();
  }

  //change event for unsubscribe maps
  onCheckboxChange(e: any, name: any): void {
    const index = this.unSubscribeArray.indexOf(e.target.value);
    if (index != -1) {
      this.unSubscribeArray.splice(index, 1);
      this.mapsName.splice(index, 1);
    } else {
      this.unSubscribeArray.push(e.target.value);
      this.mapsName.push(name);
    }
  }

  //for unsubscribing map
  unSubscribe(e: Event): void {
    e.preventDefault();
    if (this.unSubscribeArray.length != 0 && this.mapsName.length != 0) {
      this.dialog.open(EndSubscriptionComponent, {
        disableClose: true,
        data: {
          message: true,
          maps: this.mapsName,
          id: this.unSubscribeArray,
        },
        panelClass: 'app-full-bleed-dialog',
        backdropClass: 'bdrop',
      });
    } else {
      const dialogRef = this.dialog.open(UnsubscribeModalComponent, {
        disableClose: true,
        data: { message: false, maps: this.mapsName },
        panelClass: 'app-full-bleed-dialog',
        position: {
          top: '10%',
          left: '70%',
        },
        backdropClass: 'bdrop',
      });
      dialogRef.afterClosed().subscribe(() => {
        this.mapsName = [];
        this.unSubscribeArray = [];
      });
    }
    this.checkCancelledStatus();
  }

  //change direct login status
  onChange(e: any): void {
    this.value = e.target.value;
    this.dashboardService
      .loginRedirectSetting({ login_directly: this.value })
      .subscribe(() => {
        localStorage.setItem('redirect', this.value);

        this.updateSetting = true;
        this.showText = 'Login redirection setting saved!'
        setTimeout(() => {
          this.checkStatus();
          this.updateSetting = false;
        }, 3000);
      });
  }

  //goto my map
  getMap(name: string, id: any, mapName: any) {
    this.mapServices.mapName = mapName
    this.global.toggleLoader(true)
    localStorage.removeItem('shared');
    const urlName = name;
    this.router.navigate(['/', urlName]);
  }

  //goto my shared maps
  getSharedMap(name: string, id: any, mapName: any, collId: any) {
    this.global.toggleLoader(true)
    localStorage.setItem('collId', collId);
    localStorage.setItem('coltype', 'collaborate');
    localStorage.setItem('shared', 'true');
    localStorage.setItem('mapName', name);
    this.mapServices.mapName = mapName;
    this.mapServices
      .getMapData(name, 'false', this.share, collId.toString())
      .subscribe((res: any) => {
        if (res.message === 'All available seats are currently full.') {
          if (name === 'wildfire-viewer') {
            this.mapTitle = 'wildfireviewer';
          } else if (name === 'carr-fire' || name === 'camp-fire') {
            this.mapTitle = 'wildfiredamageviewe';
          } else {
            this.mapTitle = 'parcelviewer';
          }
          const noSeatsText =this.mapServices.getAllModals.seats_not_available
          this.dialog.open(SeatsNotAvailableComponent, {
            disableClose: true,
            panelClass: 'app-full-bleed-dialog',
            position: {
              top: '10%',
            },
            backdropClass: 'bdrop',
            data: { mapdata: this.mapTitle, text: noSeatsText},
          });
        } else {
          const urlName = name;
          this.router.navigate(['/', urlName]);
        }
      });
  }

  onChangeFont(val: any) {
    this.updateSetting = true;
    this.showText = 'Font setting saved!'
    setTimeout(() => {
      this.selectFontSize = val
      this.mapServices.fontSize = this.selectFontSize
      localStorage.setItem("fontSize", this.selectFontSize)
      this.updateSetting = false;
    }, 3000);
  }
}
